/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 19th 2022, 9:41:41 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate } from "lib/schemas";
import { EmphasisText, InputHelpDialogWrapper } from "ui-widgets";
import { useOSFormContext } from "ui-widgets/forms/providers";
import { TaskTemplateInput } from "./TaskTemplateInput";

export const DataAssociationNodeSetting = () => {
  const { watch } = useOSFormContext<TaskTemplate>();
  const [processDefinitionId, title, taskType, data_output_association_node, billing_configuration] = watch<
    (keyof TaskTemplate)[]
  >(["process", "title", "type", "data_output_association_node", "billing_configuration"]) as [
    TaskTemplate["process"],
    TaskTemplate["title"],
    TaskTemplate["type"],
    TaskTemplate["data_output_association_node"],
    TaskTemplate["billing_configuration"]
  ];

  const showDataAssociationSetting =
    (taskType !== "Split" && taskType !== "End") || Boolean(data_output_association_node);

  let label = "Set a data association node";
  let helpTitle = "Data Association Node";
  let helpContent = (
    <>
      Choose the node that will use data outputted from this node (<EmphasisText>{title}</EmphasisText>) i.e. The node
      whose data input will be the output from <EmphasisText>{title}</EmphasisText>.This is a data association, where
      two nodes need to share or act on the same data object e.g. a task that may need to access a document object
      generated by a document generation task. So the document outputted by the document generated task, becomes the
      input of the task selected here.
    </>
  );

  if (Boolean(billing_configuration)) {
    label = "Set the payment task";
    helpTitle = "Set the payment task";
    helpContent = (
      <>
        Choose the task that will pay for the invoice generated by (<EmphasisText>{title}</EmphasisText>). The payment
        task you choose here will access an invoice object generated by this invoicing task and use it as input for the
        payment process.
      </>
    );
  }

  return (
    showDataAssociationSetting && (
      <InputHelpDialogWrapper helpTitle={helpTitle} helpContent={helpContent}>
        <TaskTemplateInput<TaskTemplate>
          apiQueryParams={{ process_definition: processDefinitionId }}
          schema_field_key="data_output_association_node"
          label={label}
        />
      </InputHelpDialogWrapper>
    )
  );
};
